import { useContext } from 'react';

import { DevScenarioContext } from './DevScenarioContext';

export const useDevScenarioContext = () => {
  const context = useContext(DevScenarioContext);
  if (!context) {
    throw new Error('useDevScenarioContext must be used within a DevScenarioProvider');
  }
  return context;
};
